export const DEFAULT_AVATAR_URL = '/assets/images/avatar/avatar.svg';

export const USER_PROFILE_IMAGE_PREFIX =
  'https://onthatstreet.blob.core.windows.net/content/users/profilepictures/';
export const AGENCY_PROFILE_IMAGE_PREFIX =
  'https://onthatstreet.blob.core.windows.net/content/agencies/profilepictures/';
export const CONTACT_IMAGE_PREFIX =
  'https://onthatstreet.blob.core.windows.net/content/contacts/images/';

const DEFAULT_EMPTY_IMAGE_PREFIXES = [
  USER_PROFILE_IMAGE_PREFIX,
  AGENCY_PROFILE_IMAGE_PREFIX,
  CONTACT_IMAGE_PREFIX,
];

export const resolveImageUrl = (
  value?: string | null,
  fallback = DEFAULT_AVATAR_URL,
  emptyPrefixes = DEFAULT_EMPTY_IMAGE_PREFIXES,
) => {
  const imageUrl = value?.trim();

  if (!imageUrl) {
    return fallback;
  }

  for (const prefix of emptyPrefixes) {
    if (imageUrl === prefix) {
      return fallback;
    }

    if (imageUrl.startsWith(prefix)) {
      const nestedUrl = imageUrl.slice(prefix.length);

      if (nestedUrl.startsWith('http://') || nestedUrl.startsWith('https://')) {
        return nestedUrl;
      }
    }
  }

  return imageUrl;
};

export const hasResolvedImageUrl = (value?: string | null) => resolveImageUrl(value, '') !== '';
